import React, { useCallback } from "react";
import styled from "styled-components";
import { InputWidgetProps } from ".";
import { useUserPropertyTickers } from "../../../components/user-tickers-providers";
import Select from "react-select";

const SelectGroupWrapper = styled.div`
  max-width: 300px;
`;

export function PropertyTickersListSelector({ value, onChange }: InputWidgetProps) {
  const tickers = useUserPropertyTickers();

  const options = tickers.map(it => ({ value: it, label: it }));
  const currentSelected = options.find(({ value: propertyTicker }) => propertyTicker === value);

  const handleChange = useCallback((event) => onChange(event.value), [onChange]);

  return (
    <SelectGroupWrapper>
      <Select value={currentSelected} onChange={handleChange} options={options} />
    </SelectGroupWrapper>
  );
}